export default "__VITE_ASSET__D7OTC4iy__"